import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBNH2r9q515T7U66vuF45H1E9_VLfhZEyc",
  authDomain: "restaurant-pos-lapin-dm.firebaseapp.com",
  databaseURL: "https://restaurant-pos-lapin-dm-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "restaurant-pos-lapin-dm",
  storageBucket: "restaurant-pos-lapin-dm.appspot.com",
  messagingSenderId: "632715892029",
  appId: "1:632715892029:web:8cb2c50740795d7b6d2154",
  measurementId: "G-YBV1S6F7DH"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
export const database = getDatabase(app);
const auth = getAuth(app);
export { auth };